export default __webpack_public_path__ + "static/media/1up-logo.f759e171.svg";